<template lang="pug">
  div
    .relative
      input.border.border-grey-border.rounded-4.h-32.px-10.leading-100( 
        type="text"
        @input.lazy="$emit('input', $event.target.value)"  
        @keyup="$emit('onKey', { val:$event.target.value, key:name})"
        @blur.lazy="$emit('onblur', { val:$event.target.value, key:name})"
        :value="value" 
        :disabled="isDisabled" 
        :required="required" 
        :placeholder="placeholder" 
        class="focus:border-main-0 " 
        :class="{'border-error': error, 'px-6': prefix || suffix, 'cursor-not-allowed': isDisabled, 'border-grey-borderDisable': isDisabled}" 
        :maxLength="maxLength" 
        :style="{'width': width}")
      .absolute(class="top-1/2 left-3 transform rounded -translate-y-1/2")
        slot(:name="prefix"  v-if="prefix")
      .absolute(class="top-1/2 right-3 transform rounded -translate-y-1/2")
        slot(:name="suffix"  v-if="suffix")
    .error.flex.items-center(v-show="error")
      small.text-error.pt-3(v-html="$xss(error)") 
      //$emit('onKey', { val:$event.target.value, key:name})  
</template>

<script>
export default {
  name: "Input",
  props: {
    name:String,
    value: [String, Number],
    required: Boolean,
    prefix: String,
    placeholder: String,
    suffix: String,
    maxLength: {
      type: String,
    },
    width: {
      type: String,
      default: '100%'
    },
    error: String,
    isDisabled: Boolean,
  },
  methods:{
  }
};
</script>

<style lang="scss" scoped>


</style>
